
function initBannersClic() {
      $('#panBanner').on( "click", function() {
        window.location.href = 'https://pancomido.vip'; 
  } );

        $('#saboresBanner').on( "click", function() {
        window.location.href = 'https://saboresvip.com'; 
  } );
}

function initSwiper() {
          var swiper = new Swiper("#CarrouselMobile", {
      slidesPerView: 1,
      spaceBetween: 80,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  
}


document.addEventListener('DOMContentLoaded', function () {
      initSwiper();

        const links = document.querySelectorAll('#shopify-section-template--25585044095273__hero_DTyJWq a');
  const targetElement = document.querySelector('#shopify-section-template--25585044095273__custom_liquid_YMqhwx');
  
  if (links.length > 0 && targetElement) {
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }
  
  // ===== Utilidades =====
  const normalizePath = (href) => {
    try {
      const u = new URL(href, window.location.origin);
      return u.pathname.replace(/\/+$/, ''); // sin trailing slash
    } catch { return null; }
  };

  const setHref = (a, href) => a.setAttribute('href', href);

  const safeParse = (href) => {
    try { return new URL(href, window.location.origin); } catch { return null; }
  };

  const buildWithDomain = (domain, urlObj) => {
    // Asegura un único slash entre dominio y pathname
    const base = domain.replace(/\/+$/, '');          // sin trailing slash
    const path = urlObj.pathname.startsWith('/') ? urlObj.pathname : '/' + urlObj.pathname;
    return base + path + urlObj.search + urlObj.hash;
  };

  // ===== 1) Regla anterior: collection-card__link dentro del section específico =====
  (function rewriteCollectionLinks() {
    const sectionId = 'shopify-section-template--24785513316649__collection_list_f4d6ea';
    const section = document.getElementById(sectionId);
    if (!section) return;

    const redirects = {
      '/collections/bellini'  : 'https://bellini.vip/',
      '/collections/carajillo': 'https://carajillo.vip/',
      '/collections/la-buena-fe': 'https://labuenafe.vip/'
    };

    section.querySelectorAll('a.collection-card__link').forEach((a) => {
      const rawHref = a.getAttribute('href') || a.href;
      const path = normalizePath(rawHref);
      if (!path) return;
      if (redirects[path]) setHref(a, redirects[path]);
    });
  })();

  // ===== 2) En sección Bellini: prefijar dominio manteniendo ruta y query =====
  (function rewriteProductLinksBellini() {
    const sectionId = 'shopify-section-template--24857961857321__product_list_trVG4c';
    const section = document.getElementById(sectionId);
    if (!section) return;

    const targetDomain = 'https://bellini.vip'; // sin slash final
    section.querySelectorAll('a.contents').forEach((a) => {
      const rawHref = a.getAttribute('href') || a.href;
      const u = safeParse(rawHref);
      if (!u) return;

      // Evitar mailto:, tel:, javascript:, etc.
      if (u.protocol !== 'http:' && u.protocol !== 'https:' && u.protocol !== ':') return;

      const newHref = buildWithDomain(targetDomain, u);
      setHref(a, newHref);
    });
    section.querySelectorAll('a.product-card__link').forEach((a) => {
      const rawHref = a.getAttribute('href') || a.href;
      const u = safeParse(rawHref);
      if (!u) return;

      // Evitar mailto:, tel:, javascript:, etc.
      if (u.protocol !== 'http:' && u.protocol !== 'https:' && u.protocol !== ':') return;

      const newHref = buildWithDomain(targetDomain, u);
      setHref(a, newHref);
    });
  })();

  // ===== 3) En sección Carajillo: fijar a una URL exacta =====
  (function rewriteProductLinksCarajillo() {
    const sectionId = 'shopify-section-template--24857936560425__product_list_trVG4c';
    const section = document.getElementById(sectionId);
    if (!section) return;

    const fixedHref = 'https://carajillo.vip/products/menu-platinum';
    section.querySelectorAll('a.contents').forEach((a) => {
      setHref(a, fixedHref);
    });
    section.querySelectorAll('a.product-card__link').forEach((a) => {
      setHref(a, fixedHref);
    });
  })();
});

window.onload = function () {
 initBannersClic();
}
